import React, { useState } from "react";
import { useGet, usePost } from "../../common/hooks";
import { Player } from "../../common/interfaces";
import { sortPlayersByDivisionAndJersey } from "../../common/utils";
import { Button, Col, Row } from "antd";
import { MergeCandidateInfo } from "../components/MergeCandidateInfo";

const emptyPlayer = {
  id: -1,
  firstName: "",
  lastName: "",
  email: ""
} as Player;

export function MergePlayers() {
  const [player1, setPlayer1] = useState<Player>(emptyPlayer);
  const [player2, setPlayer2] = useState<Player>(emptyPlayer);

  const allPlayers = useGet<Player[]>("/api/getPlayers");
  const mergePlayers = usePost({ uri: "/api/mergePeople", deps: [allPlayers] });

  const sortedPlayers = sortPlayersByDivisionAndJersey(allPlayers.data || []);

  function getPlayer(playerId: number): Player {
    return sortedPlayers.find(p => p.id === playerId) || emptyPlayer;
  }

  function clearPlayers() {
    setPlayer1(emptyPlayer);
    setPlayer2(emptyPlayer);
  }

  return (
    <div>
      <Row>
        <Col>
          Use this tool to merge players. There is no way to undo a merge, so
          make sure you double-check what you're doing!
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <MergeCandidateInfo
            title={"Player to merge (delete)"}
            candidate={player1}
            isGoalie={false}
            loading={allPlayers.isLoading}
            candidates={sortedPlayers}
            onChange={(playerId: number) => setPlayer1(getPlayer(playerId))}
          />
        </Col>
        <Col span={8}>
          <MergeCandidateInfo
            title={"Player to keep"}
            candidate={player2}
            isGoalie={false}
            loading={allPlayers.isLoading}
            candidates={sortedPlayers}
            onChange={(playerId: number) => setPlayer2(getPlayer(playerId))}
          />
        </Col>
      </Row>
      <Row>
        <Button
          type={"primary"}
          disabled={player1.id <= 0 || player2.id <= 0 || player1.id === player2.id}
          loading={mergePlayers.isLoading}
          onClick={() =>
            mergePlayers.send(
              { person1: player1.id, person2: player2.id },
              clearPlayers
            )
          }
        >
          Merge
        </Button>
      </Row>
    </div>
  );
}
